import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import injectSheet from 'react-jss';
import { createStakeholder, editStakeholder } from 'src/api/masters';
import { fetchAllUsersInTeam, searchTeam } from 'src/api/teams';
import Select from 'src/components/common/Select';
import { isValidArray, stops } from 'src/Library/Helper';
import { KeyLabel, StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { validateEmail } from 'src/utils/utils';

import {
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Spin,
} from 'antd';
import { useDebounce } from 'src/hooks/useDebounce';
import * as uuid from 'uuid';
import { searchDsrTemplate } from '../masters/DsrTemplate/DsrTemplate.api';
import { DsrTemplate } from '../masters/DsrTemplate/DsrTemplate.types';
// import CreateNewGroupModal from '../masters/CreateNewGroupModal';
import SearchTagsInput from 'src/components/common/SearchTagsInput';
import { tokens } from 'src/design-system';
import { interactive } from 'src/design-system/mixins';
import { commonStyles } from 'src/Library/CommonStyles';
import NewProduct from '../masters/Product/NewProduct';
import { searchProduct } from '../masters/Product/Product.api';
import { MasterRecord } from '../masters/Types.masters';
import { ENTITIES } from './ContainerUtils';

const FormItem = Form.Item;
const { useEffect } = React;

const styles = theme => ({
  formItemExtra: {
    '& .ant-form-extra': {
      paddingTop: '0 !important',
      marginTop: '0 !important',
    },
  },
  title: {
    fontSize: tokens.fontSize.h3,
    lineHeight: '16px',
    fontFamily: 'Open Sans',
    color: tokens.colors.textSecondary,
    textAlign: 'left',
    fontWeight: tokens.fontWeight.bold,
  },
  sideTitle: {
    fontSize: tokens.fontSize.h3,
    lineHeight: '22px',
    fontFamily: 'Open Sans',
    color: tokens.colors.textSecondary,
    textAlign: 'left',
    fontWeight: tokens.fontWeight.bold,
  },
  checkboxFont: {
    fontSize: tokens.fontSize.small,
    lineHeight: '12px',
    color: tokens.colors.textSecondary,
    fontFamily: 'Open Sans',
    textAlign: 'Left',
  },
  form: {
    '& .ant-form-item': {
      width: '100% !important',
    },
    ...interactive.antFormRequiredHide,
    '& .ant-form-item-label': {
      lineHeight: '26px',
    },
  },
  hintHeader: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    textAlign: 'left',
    paddingTop: '6px',
  },
  required: {
    color: tokens.colors.error,
  },
  extraStyle: {
    fontSize: tokens.fontSize.small,
    fontFamily: 'Open Sans',
    fontWeight: tokens.fontWeight.semibold,
    textAlign: 'left',
    color: tokens.colors.textSecondary,
    lineHeight: '14px',
  },
  dsrStyle : {
    backgroundColor: tokens.colors.bgSubtle,
    paddingLeft: '10px',
    marginLeft: 20,
    paddingBottom : '20px',
  },
  addMoreStyle : {
    cursor: 'pointer',
    color: tokens.colors.primary,
    marginLeft: '3px',
    fontSize: tokens.fontSize.small,
  },
  addIconStyle : {
    height: '12px',
    width: '12px',
    color: tokens.colors.primary,
    paddingTop: '2px',
  },
  deleteIconStyle :{
    cursor: 'pointer',
    color: tokens.colors.error,
    fontSize: tokens.fontSize.h3,
  },
  radioStyle : {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textSecondary,
    lineHeight: '12px',
  },
  input: {
    width: '88%',
  },
  select: {
    width: '88%',
  },
  dsrTemplate: {},
  // createGroupStyle: {
  //   color: '#1890FF',
  //   margin: '15px',
  //   cursor: 'pointer',
  // },
  dsrInputs: {
    marginTop: tokens.spacing.sm,
    ...commonStyles(theme).flexRow,
    alignItems: 'top',
  },
  dropdownStyle: {
    color: theme.primaryColor,
    fontSize: tokens.fontSize.body,
    padding: `${tokens.spacing.sm + 2}px ${tokens.spacing.ms}px`,
    cursor: 'pointer',
  },
});

interface AddCustomerProps extends
StylesProps<ReturnType<typeof styles>>,
FormComponentProps {
  editData: MasterRecord;
  isVisible: boolean;
  entityName: string;
  onClose: () => void;
  refresh: () => void;
  sendWeeklyReport: boolean;
  // type: string;
}

interface StateProps {
  createActualOrganisation: boolean;
  loading: boolean;
  checked: boolean;
  mailerChecked: boolean;
  dsrRecipients: {
    id: string;
    name?: string;
    email?: string;
  }[];
  teamOptions: any[];
  teams?: any;
  isSearching: boolean;
  confirmLoading: boolean;
  teamId?: string;
  userOptions: any[];
  prefilling: boolean;
  templates: DsrTemplate[];
  templateQuery: string;
  // isLoading: boolean;
  // allGroups: any [];
  // selectAll: boolean;
  // selectedGroups: any [];
  // isCreateNewModalVisile: boolean;
  productList: KeyLabel[];
  addProduct?: boolean;
}

const AddCustomer = (props: AddCustomerProps) => {

  const [state, setState] = useGenericState<StateProps>({
    createActualOrganisation: false,
    templates: [],
    loading: false,
    checked: true,
    mailerChecked: true,
    dsrRecipients: [{
      id: uuid(),
    }],
    templateQuery: '',
    teamOptions: [],
    isSearching: false,
    confirmLoading: false,
    userOptions: [],
    prefilling: false,
    // isLoading: false,
    // allGroups: [],
    // selectAll: false,
    // selectedGroups: [],
    // isCreateNewModalVisile: false,
    productList: [],
  });

  const {
    mailerChecked,
    checked,
    createActualOrganisation,
    userOptions,
    teamOptions,
    loading,
    teams,
    templates,
    isSearching,
    confirmLoading,
    prefilling,
    teamId,
    templateQuery,
    dsrRecipients,
    // isLoading,
    // allGroups,
    // selectAll,
    // selectedGroups,
    // isCreateNewModalVisile,
    productList,
    addProduct,
  } = state;

  const {
    editData,
    entityName,
    form,
    onClose,
    refresh,
    classes,
    isVisible,
    sendWeeklyReport,
    // type,
  } = props;

  const {
    getFieldDecorator,
    setFieldsValue,
    validateFields,
    getFieldsError,
    getFieldValue,
  } = form;

  useEffect(() => {
    // fetchAllGroups();
    if (editData?.id) prefillData();
  }, []);

  const debounceTemplate = useDebounce(templateQuery, 300);
  useEffect(() => {
    searchTemplates();
  }, [debounceTemplate]);

  const searchTemplates = async () => {
    setState({ isSearching: true });
    const response = await searchDsrTemplate({ queryString: templateQuery });
    setState({ templates: response?.data, isSearching: false });
  };

  function prefillData() {
    if (!editData) return;
    const {
      name,
      adminName,
      adminEmail,
      templateName,
      sendDsrToAdmin,
      excelTemplateId,
      sendDsr,
      sendDemurrageAlert,
      sendDetentionAlert,
      dsrRecipientList,
      pocTeamId,
      teamName,
      pocUserId,
      userName,
      sendWeeklyEtaReport,
      stakeholderCode,
      sendPodArrivalNotice
      // organisationGroups,
    } = editData || {};
    setState({ prefilling: true, templateQuery: templateName?.split(' ')[0] || '' });
    let emptyDsrRecipient: { id: string } [] = [];
    if (isValidArray(dsrRecipientList)) {
      dsrRecipientList.map((item , ind) => {
        emptyDsrRecipient.push({
          id: uuid(),
          ...item,
        });
      });
    } else {
      emptyDsrRecipient = [{ id: uuid() }];
    }
    setState({
      dsrRecipients: emptyDsrRecipient,
      checked: sendDsr,
      mailerChecked: (sendDetentionAlert && sendDemurrageAlert),
      teamId: pocTeamId,
      teamOptions: [{ key: pocTeamId, label: teamName }],
      userOptions: [{ key: pocUserId, label: userName }],
      // poc: pocUserId,
      prefilling: false,
      // selectedGroups: organisationGroups?.map((group) => ({
      //   id: group.id,
      //   name: group.name,
      // })),
    });
    setFieldsValue({
      adminName,
      adminEmail,
      dsrTemplate: excelTemplateId,
      organisationName: name,
      sendAutomaticDsr: sendDsr,
      sendAutomaticMailer: (sendDemurrageAlert && sendDetentionAlert),
      sendDsrToAdminMail: sendDsrToAdmin ? 'Yes' : 'No',
      sendWeeklyEtaReport: sendWeeklyEtaReport,
      teamId: pocTeamId,
      poc: pocUserId,
      stakeholderCode,
      sendPodArrivalNotice
    });
  }

  React.useEffect(() => {
    const { dsrRecipients } = state;
    const dsrRecipientToPrefill = {};
    if (isValidArray(dsrRecipients)) {
      dsrRecipients.map((item , ind) => {
        dsrRecipientToPrefill[`dsrRecipients['${ind}']['name']`] = item.name;
        dsrRecipientToPrefill[`dsrRecipients['${ind}']['email']`] = item.email;
      });
    }
    setFieldsValue({
      ...dsrRecipientToPrefill,
    });
  }, [dsrRecipients]);

  function handleSubmit() {
    form.validateFields(async (err, values) => {
      if (err) {
        if (getFieldValue('organisationName'))
          message.error('Invalid Email');
        else
          message.error('Please fill all required feilds')
        return;
      }
      const bodyObj = createApiCallObject(values);
      setState({
        confirmLoading: true,
      });
      if (editData && editData.id) {
        const response = await editStakeholder(bodyObj);
        if (response.isSuccess) {
          message.success(`${values.organisationName} successfully updated`);
          props.onClose();
          props.refresh();
        } else {
          message.error(response.errorMessage);
          setState({
            confirmLoading:false,
          });
          return;
        }
      } else {
        const response = await createStakeholder(bodyObj);
        if (response.isSuccess) {
          message.success(`${entityName} ${values.organisationName} successfully created`);
          props.onClose();
          props.refresh();
        } else {
          message.error(response.errorMessage);
          setState({
            confirmLoading:false,
          });
          return;
        }
      }
      setState({
        confirmLoading: false,
      });

    });
  }

  // will be used when groups can be added from this modal
  // const handleEditShipper = async (bodyObj, successMessage) => {
  //   const responses = await Promise.all([
  //     editStakeholder(bodyObj),
  //     assignGroupToOrganisation({
  //       onboardingId: editData.id,
  //       groupIds: selectedGroups.map(group => group.id),
  //     }),
  //   ]);
  //   let isPromiseAllSuccess = true;
  //   responses.forEach((response) => {
  //     if (!response.isSuccess) {
  //       isPromiseAllSuccess = false;
  //       message.error(response.errorMessage);
  //       setState({
  //         confirmLoading:false,
  //       });
  //       return;
  //     }
  //   });
  //   if (isPromiseAllSuccess) {
  //     message.success(successMessage);
  //     props.onClose();
  //     props.refresh();
  //   }
  // }

  function createApiCallObject(val) {
    const apiCallObject: any = {};
    const { entityName , editData } = props;
    if (editData?.id && editData?.org2Id)  {
      apiCallObject.id = editData.id;
      apiCallObject.stakeholderOrgId = editData.org2Id;
    }
    if (editData && editData.name) {
      apiCallObject.name = val.organisationName;
    } else {
      apiCallObject.organisationName = val.organisationName;
    }
    apiCallObject.excelTemplateId = val.dsrTemplate || null;
    apiCallObject.adminEmail = val.adminEmail;
    apiCallObject.adminName = val.adminName;
    apiCallObject.teamId = val.teamId;
    apiCallObject.userId = val.poc;
    apiCallObject.organisationType = ['SHIPPER'];
    let filteredDsrRecipients : any = [];
    filteredDsrRecipients =  val?.dsrRecipients?.filter(item => item.name && item.email) || [];
    apiCallObject.productDetailId = val.productDetailId?.map(item => (item.key)) || [];
    if (!editData) apiCallObject.createActualOrganisation = createActualOrganisation;
    if (isCustomer()) {
      apiCallObject.sendDsr = checked;
      apiCallObject.sendDemurrageAlert = mailerChecked;
      apiCallObject.sendDetentionAlert = mailerChecked;
      apiCallObject.sendDsrToAdmin = val.sendDsrToAdminMail === 'Yes' ? true : false;
      apiCallObject.stakeholderType = entityName.toUpperCase() === ENTITIES.CUSTOMER ? ENTITIES.CUSTOMER : ENTITIES.SHIPPER;
      apiCallObject.stakeholderCode = val.stakeholderCode;
      apiCallObject.dsrRecipientList = filteredDsrRecipients || [];
      apiCallObject.sendWeeklyEtaReport = val.sendWeeklyEtaReport;
      apiCallObject.sendPodArrivalNotice = val.sendPodArrivalNotice;
    }
    if (entityName.toUpperCase() === ENTITIES.SUPPLIER) {
      apiCallObject.stakeholderType = ENTITIES.SUPPLIER;
      apiCallObject.stakeholderCode = val.stakeholderCode;
    }
    return apiCallObject;
  }

  function isCustomer() {
    return entityName.toUpperCase() === ENTITIES.CUSTOMER || entityName.toUpperCase() === ENTITIES.SHIPPER;
  }

  const formItemLayout = {
    labelCol: { sm: { span: 8 }, lg: { span: 6 } },
    wrapperCol: { sm: { span: 15 }, lg: { span: 10 } },
  };
  let searchTimeOut: ReturnType<typeof setTimeout> | null = null;

  function handleTextChange(val) {
    if (val.length >= 0) {
      if (searchTimeOut) {
        clearTimeout(searchTimeOut);
      }
      setState({
        isSearching: true,
      });
      searchTimeOut = setTimeout(() => {
        searchForData(val);
      }, 300);
    } else if (searchTimeOut) {
      clearTimeout(searchTimeOut);
    }
  }

  async function searchForData(query) {
    setState({ isSearching: true });
    await searchTeams(query);
    setState({ isSearching: false });
  }

  function hasErrors() {
    const fieldsError = getFieldsError();
    const res = Object.keys(fieldsError).some((field) => {
      switch (field) {
        case 'dsrRecipients': {
          // return fieldsError[field]?.some(item => Boolean(item.email));
          return false;
        }
        default : return fieldsError[field];
      }
    });
    return res;
  }

  function handleTeamFocus() {
    const value = getFieldValue('team');
    if (!value || !value.label) {
      handleTextChange('');
    } else if (value && !(state.teamOptions && state.teamOptions.length)) {
      handleTextChange(value.label || value);
    }
  }

  function handleUserFocus() {
    const value = getFieldValue('poc');
    if (!value || !value.label) {
      handleUserChange('');
    } else if (value && !(state.userOptions && state.userOptions.length)) {
      handleUserChange(value.label || value);
    }
  }

  const renderTeamOptions = () => {
    if (isSearching) return null;
    return teamOptions.map(elem =>
      <Select.Option {...elem} key={elem.key}>{elem.label}</Select.Option>,
    );
  };

  const renderUserOptions = () => {
    if (isSearching) return null;
    return userOptions.map(elem =>
      <Select.Option
        {...elem}
        key={elem.key}>
        {elem.label}
      </Select.Option>,
    );
  };

  function handleTeamsChange(teamId) {
    setState({ teamId });
    setFieldsValue({ poc : undefined });
  }

  function handleUserChange(val) {
    if (val.length >= 0) {
      if (searchTimeOut) {
        clearTimeout(searchTimeOut);
      }
      setState({
        isSearching: true,
      });
      searchTimeOut = setTimeout(() => {
        searchForUsers(val);
      }, 300);
    } else if (searchTimeOut) {
      clearTimeout(searchTimeOut);
    }
  }

  async function searchForUsers(query) {
    setState({ isSearching: true });
    await searchUserForTeam();
    setState({
      isSearching: false,
    });
  }

  async function searchTeams(querySting: string) {
    const response = await searchTeam({ teamName: querySting });
    if (response.isSuccess) {
      setState({
        teamOptions: response.data.map(el => ({ key: el.id, label: el.name })),
      });
    } else message.error(response.errorMessage);
  }

  async function searchUserForTeam() {
    const response = await fetchAllUsersInTeam(teamId);
    if (response.isSuccess) {
      setState({
        userOptions: response.data[0].users.map(el =>
          ({ key: el.id, label: el.name || el.username || el.email }),
        ),
      });

    } else message.error(response.errorMessage);
  }

  const renderDeleteDsr = (key: string , ind: number) => {
    if (ind === dsrRecipients.length - 1) return null;
    return <Col span={2}>
      <Icon type="delete"
        style={{
          ...(ind === 0 && {
            marginTop: 12,
          }),
        }}
        className={classes.deleteIconStyle}
        onClick={() => handleDeleteDsr(key, ind)}
      />
    </Col>;
  };

  function handleDeleteDsr(key: string, ind: number) {
    let dsrRecipientList = [...(form.getFieldValue('dsrRecipients') || [])];
    dsrRecipientList = dsrRecipientList
    .filter((item, idx) => ind !== idx)
    .map(item => ({ ...item, id: uuid() }));
    setState({ dsrRecipients: dsrRecipientList });
  }

  const renderDsrEmail = (key, ind) => {
    return <Col span={8}>
      <FormItem>
      <Row
        className={classes.extraStyle}>
        {ind === 0 && 'Email'}
      </Row>
      {getFieldDecorator(`dsrRecipients['${ind}']['email']`, {
        rules: [{
          validator: emailValidator,
        }],
      })(<Input
          placeholder="Enter Email"
          className={classes.input}
        />)}
      </FormItem>
    </Col>;
  };

  const renderDsrName = (key , ind) => {
    return <Col span={8}>
      <FormItem>
      <Row
        className={classes.extraStyle}>
        {ind === 0 && 'Name'}
      </Row>
      {getFieldDecorator(`dsrRecipients['${ind}']['name']`, {
        initialValue: dsrRecipients[ind].name,
      })(<Input
      style={{width: '14rem'}}
        placeholder="Enter Name"
        className={classes.input}
      />)}
      </FormItem>
    </Col>;
  };

  const renderDsrRecTag = (ind) => {
    return <Col span={4} className={classes.hintHeader}>
      {!ind && 'DSR Recipients'}
    </Col>;
  };

  function handleAddMore() {
    let dsrRecipientList = form.getFieldValue('dsrRecipients');
    dsrRecipientList = [...dsrRecipientList]
    .map(item => ({ ...item, id: uuid() }));
    dsrRecipientList.push({ id: uuid() });
    setState({ dsrRecipients: dsrRecipientList });
  }

  const renderAddDsr = (ind) => {
    if (ind !== dsrRecipients.length - 1) return null;
    return <Row
      style={{
        marginTop: 8,
      }}
    >
      <Col span={6} />
      <Col span={4}>
        <Icon
          type="plus"
          className={classes.addIconStyle}
        />
        <a
          className={classes.addMoreStyle}
          onClick={() => handleAddMore()}
        >
          Add More
        </a>
      </Col>
    </Row>;
  };

  const renderDsrRecipients = () => {
    if (!dsrRecipients) return null;
    return dsrRecipients.map((item, ind) =>
      <div key={item.id}>
        <Row
          className={classes.dsrInputs}
        >
          {renderDsrRecTag(ind)}
          <Col span={2} />
          {renderDsrName(item.id , ind)}
          {renderDsrEmail(item.id , ind)}
          {renderDeleteDsr(item.id , ind)}
        </Row>
        {renderAddDsr(ind)}
      </div>);
  };

  const renderInternalPocTag = () => {
    return <Col span={(isCustomer()) ? 4 : 3}
      style={{ marginTop: '5px' }}>
      <span className={classes.sideTitle}>
        Internal POC {(isCustomer()) && <Icon type="question-circle" theme="filled" />}
      </span>
    </Col>;
  };

  const renderInternalPocTeam = () => {
    return <Col span={12}>
      <FormItem  {...formItemLayout} colon={false}
        label={<div className={classes.hintHeader}>Team</div>}>
        {getFieldDecorator('teamId', {
        })(
          <Select
            placeholder="Select Team"
            style={{ width: '100%' }}
            filterOption={(inputValue, option) => true}
            showSearch
            onChange={handleTeamsChange}
            onFocus={handleTeamFocus}
            onSearch={handleTextChange}
            notFoundContent={renderLoading()}
          >
            {renderTeamOptions()}
          </Select>,
        )}
      </FormItem>
    </Col>;
  };

  const renderLoading = () => {
    if (isSearching) {
      return <Spin style={{ marginLeft: '45%', marginTop: '10%' }} />;
    }
    return 'Not Found';
  };

  const renderInternalPocUser = () => {
    return <Col span={12}>
      <FormItem  {...formItemLayout} colon={false}
        label={<div className={classes.hintHeader}>POC</div>}>
        {getFieldDecorator('poc', {
        })(
          <Select
            placeholder="Select POC"
            style={{ width: '100%' }}
            disabled={Boolean(!state.teamId)}
            onSearch={handleUserChange}
            onFocus={handleUserFocus}
            notFoundContent={renderLoading()}
          >
            {renderUserOptions()}
          </Select>,
        )}
      </FormItem>
    </Col>;
  };

  const renderInternalPoc = () => {
    return <Row gutter={30} style={(isCustomer()) ?
      { marginBottom: '80px', marginTop: '20px' } :
      { marginBottom: '40px', marginTop: '20px' }}>
      {renderInternalPocTag()}
      <Col span={(isCustomer()) ? 20 : 21}>
        <Row >
          {renderInternalPocTeam()}
          {renderInternalPocUser()}
        </Row>
      </Col>
    </Row>;
  };

  const renderOrganisationName = () => {
    const { form: { getFieldDecorator }, classes } = props;
    const organisationPlaceholder = ((entityName.toUpperCase() === ENTITIES.SHIPPER) || (entityName.toUpperCase() ===  ENTITIES.SUPPLIER) || (entityName.toUpperCase() === ENTITIES.CUSTOMER)) ? entityName : 'Organisation';
    return (
        <Col span={12}>
          <FormItem  {...formItemLayout} colon={false}
          label={<div className={classes.hintHeader}>{`${organisationPlaceholder} Name`}<span
            className={classes.required}>*</span></div>}>
          {getFieldDecorator('organisationName', {
            rules: [
              { required: true, message: `${organisationPlaceholder} Name is required` },
              { max: 50, message: 'Name should not exceed length of 50 characters' },
            ],
          })(<Input
            placeholder={`${organisationPlaceholder} Name`}
            style={{ width: '100%', marginLeft: '8px' }}
          />)}
        </FormItem>
       </Col>
    );
  };

  const renderOrganisationCode = () => {
    return <Col span={12}>
      <FormItem
      {...formItemLayout}
      colon={false}
      label={<div className={classes.hintHeader}>{`${entityName} Code`}</div>}>
      {getFieldDecorator('stakeholderCode', {
        rules: [{
          max: 30, message: `${entityName} code should not exceed length of 30 characters`
        }],
      })(<Input
          placeholder={`${entityName} Code`}
          style={{ width: '100%', marginLeft: '5px' }}
        />)}
      </FormItem>
    </Col>;
  };

  const renderAdminName = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Admin Name</div>}>
        {getFieldDecorator('adminName', {
        })(<Input
          placeholder="Admin Name"
          style={{
            width: '100%',
            marginLeft: '8px',
          }}
      />)}
    </FormItem>
    </Col>;
  };

  const renderCreateActualOrg = () => {
    // if false, creates a dummy account, else creates an actual org that can have users
    if (!!editData || ![ENTITIES.CUSTOMER, ENTITIES.SUPPLIER].includes(entityName.toUpperCase())) return null;
    return <FormItem
      {...formItemLayout}
      colon={false}>
      {getFieldDecorator('createActualOrganisation', {
        initialValue: false,
      })(<Checkbox
        checked={createActualOrganisation}
        onChange={e => setState({ createActualOrganisation: e.target.checked })}>
        <span className={classes.checkboxFont}>Create a new organisation and allow stakeholder login</span>
      </Checkbox>)}
    </FormItem>
  };

  const renderAutomaticDsr = () => {
    return (
      <Row>
        <Col span={12} style={{ height: '25px' }}>
        <FormItem  {...formItemLayout} colon={false}
          label={<div className={classes.hintHeader}>DSR Settings</div>}>
          {getFieldDecorator('sendAutomaticDsr', {
            initialValue: true,
          })(<Checkbox
            checked={checked}
            onChange={e => setState({ checked: e.target.checked })}>
            <span className={classes.checkboxFont}>Send  Automatic DSR </span>
          </Checkbox>)}
        </FormItem>
      </Col>
    </Row>
    );
  };

  const renderSendWeeklyETAReport = () => {
    return <Row>
      <Col
        span={12}
        offset={3}
        style={{ height: '30px' }}>
        <FormItem colon={false}>
          {getFieldDecorator('sendWeeklyEtaReport', {
            initialValue: false,
            valuePropName: "checked",
          })(<Checkbox>
            <span className={classes.checkboxFont}>
              Send Weekly ETA Report
            </span>
          </Checkbox>)}
        </FormItem>
      </Col>
    </Row>;
  };

  function emailValidator(rule, value, callback) {
    if (value && value.length) {
      if (!validateEmail(value)) {
        return callback('Invalid Email !');
      }
    }
    return callback();
  }

  const renderAdminEmail = () => {
    return <Col span={12}>
      <FormItem
      {...formItemLayout}
      colon={false}
      label={<div className={classes.hintHeader}>Admin Email ID</div>}>
      {getFieldDecorator('adminEmail', {
        rules: [{
          validator: emailValidator,
        }],
      })(<Input
          placeholder="Admin Email"
          style={{ width: '100%', marginLeft: '5px' }}
        />)}
      </FormItem>
    </Col>;
  };

  const renderAutomaticMailers = () => {
    return <Row style={{ marginBottom: '10px' }}>
      <Col
        span={12}
        offset={3}
        style={{ height: '30px' }}>
        <FormItem colon={false}>
          {getFieldDecorator('sendAutomaticMailer', {
          })(<Checkbox
            checked={mailerChecked}
            onChange={e => setState({ mailerChecked: e.target.checked })}>
            <span className={classes.checkboxFont}>
              Send Automatic Demurrage/Detention Mailers
            </span>
          </Checkbox>)}
        </FormItem>
      </Col>
    </Row>;
  };

  const renderDsrTag = () => {
    return <Col
      span={4}
      style={{ marginTop: '5px' }}
      className={classes.sideTitle}
    >
      DSR Settings<br /> & Frequency
    </Col>;
  };

  const renderBasicInfoTag = () => {
    return <Col span={(isCustomer()) ? 4 : 3}
      style={{ marginTop: '5px' }}
      className={classes.sideTitle}>
      Basic Info
    </Col>;
  };

  const renderSendDsrAdmin = () => {
    return <Row style={{ height: '40px' }}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Send DSR to Admin Email</div>}>
        {getFieldDecorator('sendDsrToAdminMail', {
        })(<Radio.Group size="small">
          <Radio
            value={'Yes'}>
            <span className = {classes.radioStyle}>
              Yes
            </span>
          </Radio>
          <Radio
            value={'No'}>
            <span className = {classes.radioStyle}>
              No
            </span>
          </Radio>
        </Radio.Group>)}
      </FormItem>
    </Row>;
  };

  const renderDsrTemplate = () => {
    if (!isCustomer()) return null;
    return <Row style={{ height: '40px' }}>
      <FormItem
        className={classes.dsrTemplate}
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>DSR Template</div>}>
        {getFieldDecorator('dsrTemplate', {
        })(<Select
            className={classes.select}
            showSearch
            allowClear
            optionFilterProp="children"
            onSearch={templateQuery => setState({ templateQuery })}
            placeholder="Select DSR template"
            style={{ width: '100%' }}
            dropdownRender={menu => isSearching ?
              <Spin style={{ marginLeft: '45%', marginTop: '20%' }} /> : menu}
          >
            {templates?.map(item =>
              <Select.Option
                className={classes.select}
                key={item.id}>
                {item.name}
              </Select.Option>)}
        </Select>)}
      </FormItem>
    </Row>;
  };

  const renderSendPodArrivalNotice = () => {
    return <Row>
      <Col
        span={12}
        offset={3}
        style={{ height: '30px' }}>
        <FormItem colon={false}>
          {getFieldDecorator('sendPodArrivalNotice', {
            initialValue: false,
            valuePropName: "checked",
          })(<Checkbox>
            <span className={classes.checkboxFont}>
              Send POD Arrival Notice
            </span>
          </Checkbox>)}
        </FormItem>
      </Col>
    </Row>;
  }
  const renderCustomerFields = () => {
    if (!isCustomer()) return null;
    return <Row gutter={24}
      style={{ marginBottom: '15px' }}>
      {renderDsrTag()}
      <Col span={20}>
        {renderAutomaticDsr()}
        {sendWeeklyReport && renderSendWeeklyETAReport()}
        {renderSendPodArrivalNotice()}
        {renderAutomaticMailers()}
      </Col>
    </Row>;
  };

  const renderDsrDetails = () => {
    return <Row>
      <Col span={6}></Col>
      <Col
        span={17}
        className={classes.dsrStyle}
      >
        {renderDsrTemplate()}
        {renderSendDsrAdmin()}
        {renderDsrRecipients()}
      </Col>
    </Row>;
  };

  const renderBasicDetails = () => {
    return <Row gutter={24}
      style={{ marginBottom: '10px' }}>
      {renderBasicInfoTag()}
      <Col span={(isCustomer()) ? 20 : 21}>
        <Row>
          {renderOrganisationName()}
          {[ENTITIES.CUSTOMER, ENTITIES.SUPPLIER].includes(entityName.toUpperCase()) ? renderOrganisationCode(): null}
        </Row>
        <Row>
          {renderAdminName()}
          {renderAdminEmail()}
        </Row>
        {renderCreateActualOrg()}
      </Col>
    </Row>;
  };

  const renderTitle = () => {
    return <span
      className={classes.title}>
      {`${!!editData ? 'Edit' : 'Add'}
      ${entityName}`}
    </span>;
  };

  const renderFooter = () => {
    return [
      <Button
        key="back"
        onClick={() => onClose()}>
        Cancel
      </Button>,
      <Button
        key="confirm"
        type="primary"
        loading={confirmLoading}
        onClick={() => handleSubmit()}
        disabled={hasErrors()} >
        Confirm
      </Button>,
    ];
  };

  // will be used when groups can be added from this modal
  // const renderDropdown = (menu: React.ReactNode) => {
  //   if (isLoading) return <Spin style={{ marginLeft: '15px' }} />;
  //   return <React.Fragment>
  //     {menu}
  //     <div
  //       className={classes.createGroupStyle}
  //       onMouseDown={e => stops(e)}
  //       onClick={() => setState({ isCreateNewModalVisile: true })}
  //       >
  //       + Create New Group
  //     </div>
  //   </React.Fragment>;
  // };

  // function handleGroupChange(options) {
  //   const selectedAll = options.find(opt => opt.key === 'all');
  //   if (selectedAll) {
  //     setState({
  //       selectAll: !selectAll,
  //       selectedGroups: selectAll ? [] : clone(allGroups),
  //     });
  //   } else {
  //     setState({
  //       selectedGroups: options.map((opt) => {
  //         return {
  //           id: opt.key,
  //           name: opt.props.children,
  //         };
  //       }),
  //       selectAll: false,
  //     });
  //   }
  // }

  // async function fetchAllGroups() {
  //   setState({ isLoading: true });
  //   let groups = [];
  //   const response = await fetchOrganisationFFGroups(null);
  //   if (response.isSuccess) groups = response?.data || [];
  //   else message.error(response.errorMessage);
  //   setState({
  //     isLoading: false,
  //     allGroups: groups,
  //   });
  // }

  // const renderGroup = () : React.ReactElement => {
  //   return (
  //     <Row style={{ marginBottom: '40px', display: 'flex', alignItems: 'center' }}>
  //        <Col span={4} className={classes.sideTitle}>
  //           Assign Group
  //       </Col>
  //       <Col span={2} className={classes.hintHeader} style={{ marginLeft: '5px', paddingTop: 0 }}>
  //         Group Name
  //       </Col>
  //       <Col span={17} style={{ marginLeft: '22px' }}>
  //         <Select
  //           mode="multiple"
  //           placeholder="Select Group"
  //           showSearch={true}
  //           style={{ minWidth: '40%', width: 'auto' }}
  //           value={selectedGroups.length ? selectedGroups.map((group: any) => {
  //             return group.name;
  //           }) : undefined}
  //           dropdownRender={menu => renderDropdown(menu)}
  //           dropdownStyle={{ zIndex: 7000 }}
  //           onChange={(filtervals, options) => handleGroupChange(options)}
  //           showArrow={true}
  //           autoClearSearchValue={false}
  //         >
  //           {!isLoading && allGroups && allGroups.length &&
  //           <Select.Option
  //             key={'all'}
  //             value={'all'}>
  //             Select All
  //           </Select.Option>}
  //           {
  //             allGroups.map(group =>
  //               <Select.Option
  //                 key={group.id}
  //                 value={group.name}>
  //                   {group.name}
  //             </Select.Option>)
  //           }
  //         </Select>
  //       </Col>
  //     </Row>
  //   );
  // };
  const renderProductTag = () => {
    return <Col span={(isCustomer()) ? 4 : 3}
      style={{ marginTop: '5px' }}>
      <span className={classes.sideTitle}>
        Product
      </span>
    </Col>;
  };

  const renderProductLabel = () => {
    return <div
      className={classes.hintHeader}>
      <div style={{ lineHeight: '14px' }}>Product Name</div>
      <div style={{ lineHeight: '14px' }}>(Internal)</div>
    </div>;
  };

  const renderProductDropdown = (menu) => {
    return <div
      style={{ border: '1px solid rgba(0, 0, 0, 0.15)' }}>
      {menu}
      <div
        className={classes.dropdownStyle}
        onMouseDown={(e) => {
          stops(e);
          setState({ addProduct: true });
        }}>
        <Icon
          type="plus"
          style={{ marginRight: '10px' }}
        />
        Add Product
      </div>
    </div>;
  };

  const renderProductField = () => {
    return <FormItem
      className={classes.dsrTemplate}
      colon={false}
      {...{
        labelCol: { sm: { span: 3 }, lg: { span: 3 } },
        wrapperCol: { sm: { span: 12 }, lg: { span: 12 } },
      }}
      label={renderProductLabel()}>
      {form.getFieldDecorator('productDetailId', {
        initialValue: editData?.productDetails?.map(item => ({
          key: item.id,
          label: item.internalName,
        })),
      })(<SearchTagsInput
        className={classes.select}
        optionFilterProp="children"
        style={{ width: '100%' }}
        dropdownRender={renderProductDropdown}
        getPopupContainer={(trigger: any) => trigger.parentNode}
        searchFunction={searchProducts}
        placeholder="Search Product"
        options={productList}
        mode="multiple"
      />)}
    </FormItem>;
  };

  async function searchProducts(searchQuery: string) {
    const response = await searchProduct({ searchQuery });
    setState({
      productList: (response?.data || []).map(item => ({
        key: item.id,
        label: `${item.internalName} ${item?.status === 'ACTIVE' ? '' : '(Inactive)'}`
      })),
    });
  }

  const renderProduct = () => {
    return <Row gutter={24} style={(isCustomer()) ?
      { marginBottom: '80px', marginTop: '20px' } :
      { marginBottom: '40px', marginTop: '20px' }}>
      {renderProductTag()}
      <Col span={20}>
        {renderProductField()}
      </Col>
    </Row>
  };

  const renderForm = () => {
    if (prefilling) {
      return <Spin
        style = {{
          marginTop :'50%' ,
          marginLeft : '50%' }}
      />;
    }
    return <Form layout="inline" className={classes.form}>
      {renderBasicDetails()}
      {renderCustomerFields()}
      {entityName !== 'Supplier' && renderDsrDetails()}
      {renderInternalPoc()}
      {/* {entityName === 'Shipper' && type === 'FF' && renderGroup()} */}
      {renderProduct()}
    </Form>;
  };

  function handleAddProduct(addProduct: boolean) {
    setState({ addProduct });
  }

  const renderNewProduct = () => {
    if (!addProduct) return null;
    return <NewProduct
      type={entityName === 'Shipper' ? 'FF' : 'SHIPPER' }
      handleClose={() => handleAddProduct(false)}
    />;
  };

  const renderModals = () => {
    return <React.Fragment>
      {renderNewProduct()}
    </React.Fragment>;
  };

  return <Modal
    title={renderTitle()}
    width={(isCustomer()) ? 1170 : 1000}
    okText={'Submit'}
    visible={isVisible}
    closable={true}
    onCancel={() => onClose()}
    onOk={handleSubmit}
    confirmLoading={loading}
    destroyOnClose
    bodyStyle={{
      position: 'inherit',
      boxSizing: 'border-box',
      border: `1px solid ${tokens.colors.border}`,
      backgroundColor: tokens.colors.bgWhite,
    }}
    footer={renderFooter()}
  >
    {renderForm()}
    {/* {isCreateNewModalVisile &&
      <CreateNewGroupModal
        visible={isCreateNewModalVisile}
        currentGroups={allGroups}
        onClose={() => {
          setState({ isCreateNewModalVisile: false });
          fetchAllGroups();
        }}
      />} */}
    {renderModals()}
  </Modal>;
};

export default injectSheet(styles)(Form.create()(AddCustomer));
